// extracted by mini-css-extract-plugin
export default {"button":"aNIWG5","external":"bNIWG5","text":"cNIWG5","buttonBackground":"dNIWG5"};